import React, { useState } from "react";
import FerrariFondo from "../images/ferrariImagen.jpg";
import OrangeFondo from "../images/naranjaFondo.jpg"
import Construccion from "../images/construccion.jpg";

import ferrari from "../images/ferrari.jpg"
import ferrari2 from "../images/ferrari2.jpg"

import orange1 from "../images/orange1.jpg"

import Box from "@mui/material/Box";
import { Modal } from "@mui/material";
import { Carousel } from "react-responsive-carousel";

import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import styles from "react-responsive-carousel/lib/styles/carousel.min.css";

import { FaNodeJs, FaReact } from "react-icons/fa";
import { SiGraphql } from "react-icons/si";
import { SiPrisma } from "react-icons/si";
import { SiTailwindcss } from "react-icons/si";

import { RiHtml5Fill } from "react-icons/ri";

import {SiTsnode} from "react-icons/si"
import {FaDocker} from "react-icons/fa"
import {SiKubernetes} from "react-icons/si"
import {SiNextdotjs} from "react-icons/si"

const modales = [
  {
    id: 1,
    url: OrangeFondo,
    sitio: "https://responsibeorange.netlify.app/",
    codigo: "https://github.com/Yeremi528/Naranja-mecanica-",
    tecnologia: [
      {tecnologia: <SiTailwindcss className="text-3xl ml-1 text-blue-400" />},
      {tecnologia: <RiHtml5Fill className="text-3xl ml-1 text-orange-600" />},

    ],
    nested: {
      titulo: "Pagina full responsive HTML5 con Tailwind",
      imagenes: [{ imagen: OrangeFondo }, { imagen: orange1 }],
    },
  },
  {
    id: 2,
    url: FerrariFondo,
    sitio: "https://client-yeremi528.vercel.app/",
    codigo: "https://github.com/Yeremi528/Server-graphQL",
    ferrari:{title:'Ferrari'},
    tecnologia: [
        {tecnologia: <FaReact className="text-3xl ml-1 text-blue-300" />},
        {tecnologia: <SiGraphql className="text-3xl ml-1 text-purple-700" />},
        {tecnologia: <SiPrisma className="text-3xl ml-1 text-green-400" />},
        {tecnologia: <SiTailwindcss className="text-3xl ml-1 text-blue-400" />}
      ],
    nested: {
      titulo: "Base para Ecommerce.",
      imagenes: [{ imagen: FerrariFondo }, { imagen: ferrari },{imagen:ferrari2}], 
    },
  },
  {
    id: 3,
    url: Construccion,
    sitio: "https://reemplazo.vercel.app/",
    codigo: "https://github.com/Yeremi528/Microservices",
    tecnologia: [
      {tecnologia: <SiNextdotjs className="text-3xl ml-1 text-gray-800" />},
      {tecnologia: <FaDocker className="text-3xl ml-1 text-blue-700" />},
      {tecnologia: <SiKubernetes className="text-3xl ml-1 text-blue-800" />},
      {tecnologia: <SiTsnode className="text-3xl ml-1 text-blue-400" />}
    ],
  },
];

const MisProyectos = () => {
  const [open, setOpen] = useState({
    id: false,
  });
  const handleClose = () => setOpen(false);
  const handleOpen = (modal) => {
    console.log(modal.id);
    setOpen({
      ...open,
      [modal.id]: !open[modal.id],
    });
  };

  return (
    <div
      id="trabajos"
      className="w-full  h-full md:h-screen flex items-center justify-center  text-gray-300"
    >
      <div className="w-full">
        <h1 className="text-emerald-300 underline text-2xl md:text-3xl lg:text-5xl font-semibold text-center ">
          My projects
        </h1>
        <div className=" flex mt-10 h-full grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-5 md:gap-10">
          {modales.map((modal) => {
            return (
              <div key={modal.id} className=" ">
                <Card className="duration-300   sm:mt-0.5 mt-4 delay-150 hover:-translate-y-1 hover:scale-110 transition">
                  <CardMedia className="">
                    <Button
                      className="w-full"
                      onClick={() => handleOpen(modal)}
                    >
                      <img
                        className="  rounded-xl   w-full h-40 md:h-60 "
                        alt="imagenes"
                        src={modal.url}
                      />
                    </Button>
                  </CardMedia>
                  <CardContent className="">
                    <h1 className="text-center font-bold text-lg">
                    Open Modal for more information
                    </h1>
                    <div className="flex justify-center">
                      {modal.tecnologia.map(x => (
                      <h1 className="">{x.tecnologia}</h1>
                    ))}
                    </div>
                    
                  </CardContent>
                  <CardActions className="flex justify-center">
                    <a
                      target="_blank"
                      className="bg-emerald-400 py-2 px-2 rounded-xl text-gray-200"
                      href={modal.sitio}
                    >
                      See Site
                    </a>
                    <a
                      target="_blank"
                      className="bg-emerald-400 py-2 px-2 rounded-xl text-gray-200"
                      href={modal.codigo}
                    >
                      See code
                    </a>
                  </CardActions>
                </Card>

                {modal.nested ? (
                  open[modal.id] ? (
                    //Activado
                    <Modal
                      className="m-auto h-5/6   w-2/3"
                      onClose={handleClose}
                      open={true}
                    >
                      <Box className="bg-slate-800   w-full h-full">
                       <CardMedia className="">
                         <Carousel>
                            {modal.nested.imagenes.map((x) => {
                            return (
                              <div className="w-5/6 m-auto h-full">
                                <div className="h-full flex">
                                  <img className="h-full w-full" src={x.imagen} />
                                </div>
                              </div>
                            );
                          })}
                         </Carousel>
                       </CardMedia>
                       
                        {modal.ferrari ? (
                          <Box className="w-10/12 m-auto h-1/5">
                            <h1 className="text-gray-300 text-xl">Ferrari Shop</h1>
                            <h4 className="text-gray-500 text-lg">Base for store sales</h4>
                            <div className="border border-gray-500 mt-4 w-full"></div>
                            <h4 className="font-bold text-gray-300">In this project I wanted to make a base for a project which can
                               vary across multiple stores with an attractive background at first login
                               with JWT so we don't forget our user log out option and an ability to get
                               the information of each user
                            </h4>

                          </Box>
                        ) : (
                          <Box className=" w-10/12 m-auto h-1/5">
                            <h1 className="text-gray-300 text-xl">Clockwork Orange copy</h1>
                            <h4 className="text-gray-500 text-lg">Imdb</h4>
                            <div className="border border-gray-500 mt-4 w-full"></div>
                            <h4 className="font-bold text-gray-300">In this project I wanted to demonstrate my ability to copy a Page visually
                             only with Tailwind to imply and demonstrate that I have no problem working with Figma.
                            </h4>
                          </Box>
                        )}
                      </Box>
                    </Modal>
                  ) : (
                    //Desactivado
                    <h4 className="text-center mt-4 font-semibold"></h4>
                  )
                ) : (
                  <div>
                    <h1 className="mt-4 font-semibold text-gray-300"></h1>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MisProyectos;
